import * as React from "react";
import { API_BASE_URL } from '../../../config/apiConfig';
import styled from 'styled-components';
import CatWithBag from '../../../assets/profile/cat-box.png';
import ShoppingCat from '../../../assets/shopping_cat.png';
import {
  Container,
  ContentWrapper,
  Section,
  SectionContent,
  SectionTitle,
  ProfileItem,
  FormField,
  Label,
  Input,
  EditText
} from '../styled/ProfileStyles';

function ProfileDetails({ profile, setProfile }) {
  const [address, setAddress] = React.useState(profile.address || '');
  const [pincode, setPincode] = React.useState(profile.pincode || '');
  const profileData = profile ? [
    { label: "Name", value: `${profile.firstname} ${profile.lastname}` },
    { label: "Gender", value: profile.gender },
    { label: "Date of Birth", value: profile.dob },
    { label: "Phone", value: profile.mobile },
    { label: "Email", value: profile.email },
  ] : [];

  const handleSaveClick = async () => {
    const token = sessionStorage.getItem('token');
    const body = {
      address,
      pincode,
    };

    if (token && body) {
      try {
        const response = await fetch(`${API_BASE_URL}/user/update-profile`, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token
          },
          body: JSON.stringify(body)
        });

        if (response.ok) {
          const updatedProfile = await response.json();
          setProfile(updatedProfile);
        } else {
          console.error('Failed to update profile. Please try again.');
        }
      } catch (error) {
        console.error('Error updating profile:', error);
      }
    }
  };

  return (
    <RelativeContainer style={{ marginBottom: '10px' }}>
      <ContentWrapper>
        <Section>
          <SectionContent>
            <SectionTitle>Profile details</SectionTitle>
            {profileData.map((item, index) => (
              <ProfileItem key={index}>{item.value}</ProfileItem>
            ))}
          </SectionContent>
        </Section>
        <Section>
          <SectionContent>
            <SectionTitle>Shipping details</SectionTitle>
            <PostalCode>{pincode}</PostalCode>
            <Address>
              {profile.address ? profile.address.split('\n').map((line, index) => <div key={index}>{line}</div>) :
                (profile.professionAddress ? profile.professionAddress.split('\n').map((line, index) => <div key={index}>{line}</div>) : '')}
            </Address>
            {!profile.pincode && (
              <EditText>
                <FormField>
                  <Label htmlFor='Pin code'>Pin code</Label>
                  <Input
                    type="text"
                    id='Pin code'
                    value={pincode}
                    onChange={(e) => setPincode(e.target.value)}
                  />
                </FormField>
                <AddressFields>
                  <AddressField>
                    <AddressLabel htmlFor={'Your shipping address'}>
                      Your shipping address
                    </AddressLabel>
                    <Input
                      style={{ height: '100px' }}
                      type="text"
                      id={'Your shipping address'}
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </AddressField>
                </AddressFields>
                <button onClick={handleSaveClick}>Save</button>
              </EditText>
            )}
          </SectionContent>
        </Section>
      </ContentWrapper>
      <ShoppingCatImage src={CatWithBag} alt="Welcome Cat" />
      <CatWithBagImage src={ShoppingCat} alt="Welcome Cat" />

    </RelativeContainer>
  );
}
const AddressField = styled.div`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 100%;
  margin-left: 0px;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const AddressLabel = styled.label`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  font-size: 12px;
  color: #202023;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  line-height: 130%;
  font-family: Metrophobic, sans-serif;
  @media (max-width: 991px) {
    margin-top: 0px;
  }
`;
const AddressFields = styled.div`
  margin-top: 10px;
  display: flex;
  gap: 20px;
  flex-direction: row;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 20px;
    flex-direction: column;
  }
`;
const PostalCode = styled.div`
  font-family: Metrophobic, sans-serif;
  letter-spacing: -0.32px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Address = styled.div`
  font-family: Metrophobic, sans-serif;
  line-height: 21px;
  margin-top: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const RelativeContainer = styled(Container)`
  position: relative;
`;

const ShoppingCatImage = styled.img`
  position: absolute;
  top: 10%; /* Adjust as needed */
  right: -80px; /* Adjust as needed */
  width: 120px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;
const CatWithBagImage = styled.img`
  position: absolute;
  bottom: 2%; /* Adjust as needed */
  left: -80px; /* Adjust as needed */
  width: 150px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;

export default ProfileDetails; 